// When card photos are taken. Each one renders a game world off-screen: cheap on a graphics card, seconds of
// frozen interface when the browser draws in software. "auto" therefore keeps the pictograms there.

export const PHOTO_MODES = ['auto', 'on', 'off'] as const;
export type PhotoMode = (typeof PHOTO_MODES)[number];

export const photosWanted = (mode: unknown, software: boolean): boolean => mode === 'on' || (mode !== 'off' && !software);

/**
 * Order in which a screen's photos are taken: the leading card of every row (the selected one, else the first)
 * before the rest, so each row shows a photo early instead of waiting for the rows above it to finish.
 */
export function leadsFirst<T>(rows: { items: T[]; lead?: number }[]): T[] {
  const heads: T[] = [], rest: T[] = [];
  for (const { items, lead = 0 } of rows) {
    const i = lead >= 0 && lead < items.length ? lead : 0;
    items.forEach((x, j) => (j === i ? heads : rest).push(x));
  }
  return [...heads, ...rest];
}
